export function getAvailableFocus(data) {
  if (data.length === 0) {
    return;
  }

  const allFocalPoints = [];
  Object.entries(data).forEach(([, value]) => {
    const categories = [
      value.acf.reader_profile_focus_hdfocus,
      value.acf.reader_profile_focus_genre,
      value.acf.reader_profile_focus_expertise,
    ];

    for (let i = 0; i < categories.length; i++) {
      Object.entries(categories[i]).forEach(([key, innerValue]) => {
        if (innerValue === true) {
          const split = key.split('_');
          allFocalPoints.push(split[split.length - 1]);
        }
      });
    }
  });
  const uniqueFocalPoints = allFocalPoints
    .filter((item, pos, self) => self.indexOf(item) === pos);

  return uniqueFocalPoints;
}
